import { Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { InlineBanner } from "~/components/InlineBanner"
import { CountryCell } from "~/components/cells/CountryCell"
import { FindCertificateRequestsForSupplierResponseDto } from "~/gen/api"

type Props = {
  productionSite: FindCertificateRequestsForSupplierResponseDto["productionSite"]
}
export function CertificateRequestProductionSite({ productionSite }: Props) {
  const { t } = useTranslation("traceability")
  if (!productionSite)
    return (
      <InlineBanner
        message={
          <Text c="blue.9">{t("certificates.productionSitePending")}</Text>
        }
        size="xs"
        type="info"
        closable={false}
        w="fit-content"
      />
    )
  return (
    <Stack gap={0}>
      <Text>{t("certificates.productionSite")}</Text>
      <Stack gap={0}>
        <Text fw="bold">{productionSite.name}</Text>
        <Stack c="gray" gap={0}>
          <Text fz="10px" fs="italic">
            {productionSite.address}
          </Text>
          <CountryCell countryIso3166={productionSite.countryIso3166} />
        </Stack>
      </Stack>
    </Stack>
  )
}
